import {
  Link_Target,
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../ricos-schema/legacy/wix/rich_content/v1";
const DEFAULTS = Object.freeze({
  config: {
    alignment: "center",
    size: "content",
    showTitle: true,
    showDescription: true
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    textWrap: true
  }
});
const imageModals = {
  settings: `${Node_Type.IMAGE}.settings`,
  imageEditor: `${Node_Type.IMAGE}.imageEditor`
};
const IMAGE_BUTTONS = {
  size: `${Node_Type.IMAGE}.size`,
  alignment: `${Node_Type.IMAGE}.alignment`
};
const tiptapImageAttributeDefaults = {
  image: { src: null, width: null, height: null, duration: null },
  link: { target: Link_Target.SELF, url: null, anchor: null, rel: null, customData: null },
  disableExpand: null,
  altText: null,
  disableDownload: null,
  containerData: {
    spoiler: { enabled: null, description: null, buttonText: null },
    ...RICOS_DEFAULTS
  },
  loading: {
    default: false
  },
  loadingPercentage: {
    default: null
  },
  tempData: {
    default: null
  }
};
export {
  DEFAULTS,
  IMAGE_BUTTONS,
  RICOS_DEFAULTS,
  imageModals,
  tiptapImageAttributeDefaults
};
//# sourceMappingURL=consts.js.map
